import React, { useState } from "react";


export default function AgentPayNowForm({ agentDetails, baseName, fetchHistory, fetchAgentDetails, token }) {
  const maxAmount = Number(agentDetails?.agentCommission?.commissionPendingAmount || 0);

  const [amount, setAmount] = useState("");
  const [remark, setRemark] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const API_URL = process.env.REACT_APP_BASE_URL_API || "";

  const handleAmountChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "");

    if (Number(value) > maxAmount) {
      setError(`Amount cannot be greater than ₹${parseFloat(maxAmount || 0).toFixed(2)}`);
    } else {
      setError("");
    }

    setAmount(value);
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  setError({});
  setLoading(true);

  if (!amount || Number(amount) <= 0) {
    setError({ amount: "Please enter valid amount" });
    setLoading(false);
    return;
  }

  if (Number(amount) > maxAmount) {
    setError({ amount: `Amount cannot be greater than ₹${parseFloat(maxAmount || 0).toFixed(2)}` });
    setLoading(false);
    return;
  }

  if (!remark) {
    setError({ remark: "Please enter remark" });
    setLoading(false);
    return;
  }

  const payload = {
    amount: Number(amount),
    remark
  };
  
  try {
    const url = `${API_URL}/api/admin/agents/create-payment/${baseName}`;

      const response = await fetch(url, {
      method: "POST",
      headers: {
          Authorization: `Bearer ${token}`,   
          "Content-Type": "application/json"
        },
      body: JSON.stringify(payload)
    });

    const result = await response.json();

    if (!response.ok || !result.status) {
      throw new Error(result.message || "Payment failed");
    }

    setMessage('Payment submitted successfully');

    setAmount("");
    setRemark("");

     fetchAgentDetails();
     fetchHistory(1);

  } catch (err) {
    console.error("Payment API Error:", err);
    setError({ api: err.message || "Something went wrong" });
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="x_panel">
      <div className="x_title">
        <h2>
          Agent Name : {agentDetails?.name} (#{agentDetails?.agentID})
        </h2>
        <div className="clearfix" />
      </div>

      <form onSubmit={handleSubmit}>
        <div className="x_content">
          <div className="row">
            <div className="col-sm-12">
              <div className="filtercont">
                <div className="row">

                  {/* Amount To Be Paid */}
                  <div className="col-12 col-sm-4 mb-3">
                    <label>Amount To Be Paid</label>
                    <input
                      type="text"
                      className="form-control"
                      value={parseFloat(maxAmount || 0).toFixed(2)}
                      disabled
                    />
                  </div>

                  {/* Enter Amount */}
                  <div className="col-12 col-sm-4 mb-3">
                    <label>Enter Amount</label>
                    <input
                      type="text"
                      className="form-control"
                      name="amount"
                      value={amount}
                      onChange={handleAmountChange}
                      placeholder="Enter amount"
                    />
                    {error && (
                      <p className="text-danger">{error.amount}</p>
                    )}
                  </div>

                  <div className="col-12" />

                  {/* Remarks */}
                  <div className="col-12 col-sm-8 mb-3">
                    <label>Remarks</label>
                    <textarea
                      className="form-control"
                      name="remark"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                    />
                    {error && (
                      <p className="text-danger">{error.remark}</p>
                    )}

                  </div>

                  <div className="col-12" />

                  {/* Submit */}
                  <div className="col-12 col-sm-8 text-right">
                    <button
                      type="submit"
                      className="btn sitebtn"
                      disabled={loading}
                    >
                      Pay Now
                    </button>
                    <p className="text-success">{message}</p>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}